<template>
  <div>
    <p
      v-if="!day.entry && !addNewEntry"
    >You haven't logged any entries for this day yet. Please click the button below to get started.</p>

    <a
      v-if="!addNewEntry"
      class="add-entry button button--standard"
      href="#"
      @click.prevent="addNewEntry = true"
    >Add new activity entry</a>

    <form @submit.prevent="submitForm" v-if="addNewEntry">
      <div class="field">
        <p>Activity type</p>
        <div class="radio-wrapper">
          <input
            type="radio"
            name="activity-type"
            id="exercise"
            value="Exercise"
            v-model="form.activityType"
            required
          >
          <label for="exercise">Physical activity/exercise</label>
        </div>
        <div class="radio-wrapper">
          <input
            type="radio"
            id="lifestyle"
            name="activity-type"
            value="Lifestyle"
            v-model="form.activityType"
            required
          >
          <label for="lifestyle">Lifestyle</label>
        </div>
      </div>

      <div v-if="form.activityType">
        <div class="field">
          <label for="activity">
            <span>Activity</span>
            <select name="activity" id="activity" v-model="form.activity" required>
              <option
                v-for="(option, index) in activityOptions"
                :key="index"
                :value="option"
              >{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="field">
          <label for="activity-time">
            <span>Time of activity</span>
            <input
              type="time"
              id="activity-time"
              v-model="form.activityTime"
              required
              @invalid="invalidTime"
            >
          </label>
        </div>

        <div class="field">
          <label for="activity-minutes">
            <span>Number of minutes of activity</span>
            <select
              name="activity-minutes"
              id="activity-minutes"
              v-model="form.activityMinutes"
              required
            >
              <option value="0">0min</option>
              <option value="5">5min</option>
              <option value="10">10min</option>
              <option value="15">15min</option>
              <option value="30">30min</option>
              <option value="45">45min</option>
              <option value="60">60min</option>
              <option value="75">75min</option>
              <option value="90">90min</option>
            </select>
          </label>
        </div>

        <div class="field">
          <label for="intesity">
            <span>Intesity of activity</span>
            <select name="intensity" id="intensity" v-model="form.activityIntensity">
              <option value="Sedentary">Sedentary</option>
              <option value="Mild">Mild</option>
              <option value="Moderate">Moderate</option>
              <option value="Vigorous">Vigorous</option>
            </select>
          </label>
        </div>

        <div class="field">
          <button type="submit" class="button button--standard">Log your activity</button>
          <button @click="addNewEntry = false" class="button button--danger">Cancel</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "Form",

  props: ["day", "existingEntry"],

  data() {
    return {
      addNewEntry: false,
      exercise: [
        "Light walking",
        "Brisk walking",
        "Jogging/Running",
        "Cycling",
        "Swimming",
        "Dancing",
        "Team sport",
        "Stretching",
        "Strength training"
      ],
      lifestyle: [
        "Walking",
        "Climbing stairs",
        "Grocery shopping",
        "Housework",
        "Cycling"
      ],
      form: {
        activityType: "",
        activity: "",
        activityTime: "",
        activityMinutes: 0,
        activityIntensity: ""
      }
    };
  },

  methods: {
    submitForm() {
      this.addNewEntry = false;

      this.$emit("form-submit", this.form, this.day);

      this.form = {};
    },

    invalidTime({ target }) {
      target.setCustomValidity("Please enter a valid time.");
    }
  },

  computed: {
    activityOptions() {
      return this.form.activityType === "Exercise"
        ? this.exercise
        : this.lifestyle;
    }
  }
};
</script>

<style>
button {
  margin-right: 1rem;
}
p {
  margin-top: 0;
}
</style>
